import { useEffect } from 'react';
import { Col, Form, Popconfirm, Row } from 'antd';

import FormInputNumber from '@/views/components/Inputs/FormInputNumber';

import { ReactComponent as DeleteIcon } from '../../../../../../../../assets/icons/delete-icon.svg';
import IconButton from '../../../../../../../components/Buttons/IconButton';
import SvgConverter from '../../../../../../../components/Common/SvgConverter';
import FormInput from '../../../../../../../components/Inputs/FormInput';
import HiddenFormInput from '../../../../../../../components/Inputs/HiddenFormInput';
import Paper from '../../../../../../../components/Paper/Paper';
import SaveCancelButtons from '../../../../../../Shipment/components/SaveCancelButtons';

const OverChargeSettlementCard = ({
  isLastItem = false,
  shadowVisible = true,
  index = 0,
  settlementDetails,
  handleDelete,
  onFieldChange,
  registerForm,
  handleSubmit,
  editMode = false,
  setEditMode,
  handleCancel,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (registerForm) {
      const settlementKey = settlementDetails.settlementSeq;
      registerForm(settlementKey, form);
      return () => {
        registerForm(settlementKey, null);
      };
    }
  }, [form, settlementDetails.settlementSeq, registerForm]);

  const initialValues = {
    ...settlementDetails,
    amount: settlementDetails?.amount != null ? Number(settlementDetails.amount) : undefined,
  };

  const setAmountValues = () => {
    const value = form.getFieldValue('amount');
    if (value !== null && value !== undefined) {
      form.setFieldValue('amount', Number(value));
    }
  };

  const isEditContext = Boolean(registerForm);
  const isFormEditable = isEditContext || editMode;

  return (
    <Paper className={`border-muted ${!isLastItem ? 'mb-16' : ''} ${shadowVisible ? '' : 'shadow-none'}`}>
      <Form
        key={`${settlementDetails?.settlementSeq}-${settlementDetails?.amount}-${settlementDetails?.accountingCode}-${settlementDetails?.isNew}`}
        onFinish={(data) => {
          const submitData = {
            ...data,
            amount: data.amount !== null && data.amount !== undefined ? Number(data.amount) : undefined,
          };
          handleSubmit(submitData, index);
        }}
        onValuesChange={onFieldChange}
        form={form}
        initialValues={initialValues}
      >
        <div className="px-16 pt-8 pb-10 " style={{ minHeight: '130px' }}>
          <Row align="middle" justify="space-between align-items-center" gutter={30}>
            <Col sm={8}>
              <FormInput
                label="Accounting Code"
                placeholder="Enter Accounting Code"
                margin="mb-0"
                name="accountingCode"
                editMode={isFormEditable}
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  {
                    message: 'Please enter Accounting Code',
                    required: true,
                  },
                ]}
                maxLength={20}
              />
            </Col>
            <Col sm={8}>
              <FormInputNumber
                label="Amount"
                placeholder="Enter Amount"
                margin="mb-0"
                name="amount"
                editMode={isFormEditable}
                validateTrigger={['onChange', 'onBlur']}
                rules={[
                  {
                    message: 'Please enter Amount',
                    required: true,
                  },
                ]}
                allowNegative
                precision={2}
                onBlur={setAmountValues}
              />
            </Col>
            <Col className="flex-1">
              <Row align="middle" justify="end">
                <Col>
                  {isEditContext ? (
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure you want to delete this settlement?"
                      onConfirm={() => handleDelete(index)}
                      okText="Delete"
                      cancelText="Cancel"
                      okType="danger"
                      autoFocus
                      getPopupContainer={(trigger) => trigger.parentElement}
                    >
                      <IconButton dataTestId={`delete-${index}`}>
                        <SvgConverter Icon={DeleteIcon} color="iconDanger" />
                      </IconButton>
                    </Popconfirm>
                  ) : (
                    <SaveCancelButtons
                      editMode={editMode}
                      lightMode={false}
                      setEditMode={(val) => setEditMode?.(index, val)}
                      handleRemove={() => handleDelete(index)}
                      isNew={settlementDetails.isNew}
                      idSuffix={`product-details-${index + 1}`}
                      isModified
                      onCancel={() => handleCancel?.(index, settlementDetails.isNew)}
                    />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <HiddenFormInput name="settlementSeq" />
        <HiddenFormInput name="isNew" />
      </Form>
    </Paper>
  );
};

export default OverChargeSettlementCard;
